import { DateTime } from 'luxon';

/** Valores que chegam de datepickers (DateTime com o adaptador Luxon), da API (ISO) ou de código antigo (Date). */
export type DateInput = Date | DateTime | string | null | undefined;

export class DateUtils {
    /** Normaliza qualquer entrada de data para um DateTime local; null se ausente ou inválida. */
    static toDateTime(value: DateInput): DateTime | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        const dateTime = DateTime.isDateTime(value)
            ? value
            : value instanceof Date
                ? DateTime.fromJSDate(value)
                : DateTime.fromISO(value);
        return dateTime.isValid ? dateTime : null;
    }

    // Converte um objeto Date em ticks
    static dateToTicks(date: Date): number {
        return date.getTime();
    }

    // Converte ticks em um objeto Date
    static ticksToDate(ticks: number): Date {
        return new Date(ticks);
    }

    // Converte uma data em ticks do .NET (100 ns desde 01/01/0001)
    static momentDateToTicks(date: DateInput): number {
        const jsTicks = DateUtils.toDateTime(date)?.toMillis() ?? 0;
        const ticksPerMillisecond = 10000;
        const cSharpEpochTicks = 621355968000000000; // Ticks desde 1º de janeiro de 0001 até 1º de janeiro de 1970 (em 100 nanosegundos)

        return (jsTicks * ticksPerMillisecond) + cSharpEpochTicks;
    }

    static dateToString(date: DateInput): string {
        return DateUtils.toDateTime(date)?.toFormat('yyyy-LL-dd') ?? '';
    }

    static momentDateToString(date: DateInput): string | null {
        return DateUtils.toDateTime(date)?.toFormat('yyyy-LL-dd') ?? null;
    }

    static getCurrentTime(): string {
        return DateTime.now().toFormat('HH:mm');
    }
}
